import React, { useState } from "react";
import "./events.css";
import { Link } from "react-router-dom";
import api from "../../services/axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Events = () => {
  const [notifyEmail, setNotifyEmail] = useState("");

  // const [errorNotify, setNotifyError] = useState(null);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);

    if (!notifyEmail) {
      toast.error("Please provide an email address.");
      setIsSubmitting(false);
      return;
    }

    if (!validateEmail(notifyEmail)) {
      toast.error("Please enter a valid email address.");
      setIsSubmitting(false);
      return;
    }

    try {
      const result = await api.get(`/api/check_added_email`, {
        params: { email: notifyEmail, table: "notify" },
      });

      if (result.data.Status) {
        // Assuming result.data.Status indicates email exists
        toast.error("Email already exists. Thank you for your registration.");
        setIsSubmitting(false);
        return; // Stop further execution if email exists
      }
    } catch (err) {
      console.error("Axios error:", err);
      console.log("Here at check");
      setIsSubmitting(false);
      toast.error("An error occurred while checking the email. Please try again later.");
      return; // Stop further execution in case of an error
    }

    try {
      console.log("notifyEmail", notifyEmail);
      const res = await api.post(`/api/notify`, { notifyEmail });
      if (res.status === 200) {
        // alert("Email sent successfully");
        toast.success("Thank you! We will notify you for the launch.");
        setIsSubmitting(false);
        setNotifyEmail("");
      } else {
        toast.error("An error occurred while processing your request. Please try again later."
        );
        setIsSubmitting(false);
        return;
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error(
        "An error occurred while processing your request. Please try again later."
      );
      setIsSubmitting(false);
      return;
    }
  };

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  return (
    <div>
      <div className="news__content">
        <div className="news__content__Info">
          <h3>GG-M EVENTS</h3>
          <p>
            Explore the latest news and gain insight on the activities
            undertaken in our aim to empower women aged 50+ to engage in
            sports and physical activites. We also take parts in various
            social intiatives and events geared towards addressing various
            issues affecting women in this age group.
          </p>
        </div>
      </div>
      <div className="events" >
        {/* <div className="events__insight_div">
          <h2>WHAT WE DO</h2>
          <h3>Latest & Upcoming Events</h3>
          <p>
            <a href="/blog">READ OUR BLOGS</a>
          </p>
          <p>
            <a href="/news">NEWS & REPORTS</a>
          </p>
        </div> */}
        <div className="events__articles_div">

          <div className="events_news_blog_articles">
            <div className="events_news_blog_article">
              <div></div>
              <div>
                <h3>NEWS . MAY 1, 2026</h3>
                <h4>Golden Girls Health & Well-Being launch!!</h4>
                <div>
                  <span style={{ fontWeight: 'bold', textAlign: 'flex-start', margin: '10px 0', fontSize: '20px', color: '#7d0dc3' }}>Join us at our launch event!</span>
                  <p><strong>Venue:</strong> Impala Club, Nairobi</p>
                  <p><strong>Date:</strong> Monday, June 1, 2026</p>
                  <p><strong>Time:</strong> 11: 00 AM - 3:00 PM</p>
                  <p><strong>Dress Code:</strong> Come Dressed to Move</p>
                  <p><strong>Registration Fee:</strong> KES 2, 000</p>
                  <strong>Contact us:</strong> 254 116 309 588 or info@goldengirlshealthandwellbeing.org
                  <button class="registerLaunchBtn" onClick={() => window.open('https://forms.gle/CHz9Mo8wKeqHCK4x7', '_blank', 'noopener,noreferrer')}>Register</button>
                </div>
              </div>
              <div>
                <img src={require("../../assets/impala.webp")} alt="impalaClub" className="impalaClub"></img>
              </div>
            </div>
            <hr />
            <div>
              <h3>NEWS . FEBRUARY 8, 2024</h3>
              <h4>Golden Girls Health & Well-Being launch</h4>
              <Link to="">Stay tuned for our launch. Coming soon!</Link>
              <div className="notifyLaunchDiv">
                <p>NOTIFY ME!</p>
                <input
                  type="email"
                  className="notify__email"
                  name="notifyEmail"
                  placeholder="Enter Your Email"
                  value={notifyEmail}
                  onChange={(e) => {
                    setNotifyEmail(e.target.value)
                  }}
                ></input>
                <button class="notifyBtn" onClick={handleSubmit} disabled={isSubmitting}>{isSubmitting ? "Submitting..." : "Submit"}</button>
              </div>
            </div>
          </div>
          <hr />
        </div>
        <ToastContainer />
      </div>
    </div >
  );
};

export default Events;
